import {
	IconButton,
	Typography,
	Grid,
	Box,
	Stack,
	debounce,
	ListItemText,
	List,
	Icon,
	ListSubheader,
	ListItem,
} from '@mui/material';

import React, { useCallback, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { isEqual } from 'lodash';

import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import AccordionComp from 'common/components/Accordion/AccordionComp';
import ButtonComp from 'common/components/Button/ButtonComp';
import { Loader } from 'common/components/Loader/Loader';
import CommonTable from 'common/components/Table/CommonTable';
import { Column } from 'common/components/Table/CommonTableStyles';
import TextFieldWithLabel from 'common/components/TextFieldWithLabel/TextFieldWithLabel';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import {
	APP_GENERAL_ERROR_MSG,
	APP_GENERAL_SAVE_LABEL,
	APP_GENERAL_CANCEL_LABEL,
	GENERIC_ERROR_MSG,
	APP_GENERIC_BAD_REQUEST_MSG,
} from 'common/constants/TextContent';
import { WORKFLOW_TEXT_CONSTANTS } from 'common/constants/WorkflowConstants';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import {
	setWorkflowStepFlag,
	setWorkflowStepDrawer,
} from 'common/store/reducer/workflowReducer';
import {
	addUsersToStateList,
	toSentenceCase,
} from 'common/utils/utilFunctions';

import { AutoComplete } from 'features/common/AutoCompleteSelect/AutoComplete';
import { IUserSelectListOptions } from 'features/Settings/api/type-def';
import UsersListSelection from 'features/Settings/Components/UsersListSelection/UsersListSelection';

import {
	createWorkflowStep,
	getSearchQueueList,
	updateWorkflowStep,
} from '../api';
import {
	UserPayloadInterface,
	IQueueSearchList,
	IEditWorkflowStepParams,
} from '../api/type-def';

import styles from './WorkflowStep.module.scss';

interface IWorkflowStepFormData {
	workflowStepName: string;
	queueIds: any[];
	users: UserPayloadInterface[];
	workflowId: string;
	workflowStepId?: string;
	queueDetail?: any[];
	userDtoDetail?: any[];
}
export interface IWorkflowStepSearchLoaderInterface {
	queueIds: boolean;
	users: boolean;
}

const {
	CREATE,
	EDIT,
	WORKFLOW_STEP_CREATED,
	WORKFLOW_STEP_UPDATED,
	ADD_QUEUES,
	CREATE_WORKFLOW_TITLE,
	CREATE_WORKFLOW_ASSIGNEE_LABEL,
} = WORKFLOW_TEXT_CONSTANTS;

const { OK, BAD_REQUEST, CREATED } = HTTP_STATUS_CODES;

const { drawerCloseImgColor, deleteIconFillColor } = styles;

const WorkflowStep = () => {
	const dispatch = useDispatch();
	const openWorkflowDrawer = useSelector(
		(state: RootState) => state.workflowmodule.workflowStepDrawer,
	);

	const selectedWorkflowDetails = useSelector(
		(state: RootState) => state?.workflowmodule?.workflowStepDetails,
	);
	const [isWorkflowLoading, setWorkflowLoading] =
		React.useState<boolean>(false);
	const [
		selectedWorkflowQueueListOptions,
		setSelecteddWorkflowQueueListOptions,
	] = React.useState<any[]>([]);
	const [selectedWorkflowStepQueueGridData, setWorkflowStepQueueGridData] =
		React.useState<any[]>([]);
	const [
		selectedWorkflowStepExistingQueueGridData,
		setWorkflowStepExistingQueueGridData,
	] = React.useState<any[]>([]);
	const [selectedUsersListOptions, setAllSelectedUsersListOptions] =
		React.useState<IUserSelectListOptions[] | any[]>([]);
	const [formData, setFormData] = React.useState<IWorkflowStepFormData>({
		workflowStepName:
			selectedWorkflowDetails.type === CREATE
				? ''
				: selectedWorkflowDetails?.data?.workflowStepName,
		queueIds: [],
		users: [],
		workflowId: selectedWorkflowDetails?.data?.workflowId,
		workflowStepId:
			selectedWorkflowDetails.type === CREATE
				? ''
				: selectedWorkflowDetails?.data?.workflowStepId,
		queueDetail: [],
		userDtoDetail: [],
	});
	const [workflowStepQueueOptions, setWorkflowStepQueueOptions] =
		React.useState<any[]>([]);
	const [isToastOpen, setToastOpen] = React.useState<boolean>(false);
	const [isSearchApiLoading, setSearchLoading] =
		React.useState<IWorkflowStepSearchLoaderInterface>({
			queueIds: false,
			users: false,
		});
	const [hoveredQueueId, setHoveredQueueId] = React.useState<string>();
	const [hoverQueueItem, setHoverQueueAction] = React.useState<boolean>(false);
	const [accordionExpanded, setExpanded] =
		React.useState<IWorkflowStepSearchLoaderInterface>({
			queueIds: false,
			users: false,
		});

	const [isSaveDisabled, setIsSaveDisabled] = React.useState<boolean>(false);
	const [isUsersValid, setIsUsersValid] = React.useState<boolean>(false);
	const [isQueueValid, setIsQueueValid] = React.useState<boolean>(false);

	const hoverAction = (id: string) => {
		setHoveredQueueId(id);
		setHoverQueueAction(true);
	};
	const blurAction = () => {
		setHoveredQueueId('');
		setHoverQueueAction(false);
	};

	const { message, severity } = useSelector(
		(state: RootState) => state.common.toastMessage,
	);

	const queueColumns: readonly Column[] = [
		{
			id: 'queueName',
			label: toSentenceCase('Queue Name '),
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<Typography
					data-testid="user-name"
					className={`${styles['createworkflow-queue-name']}`}
				>
					{`${params?.queueName}`}
				</Typography>
			),
		},
		{
			id: 'queueId',
			label: 'Action',
			disablePadding: false,
			isSortable: false,
			render: (params: any) => (
				<List
					data-testid="actions-column"
					onMouseOver={() => {
						hoverAction(params?.id);
					}}
					onFocus={() => hoverAction(params?.id)}
					onMouseOut={() => blurAction()}
				>
					{hoverQueueItem && hoveredQueueId === params?.queueId && (
						<Icon
							onClick={() => handleDelete(params?.queueId)}
							className={styles['workflow-list-item-delete']}
							data-testid="delete-action"
						>
							<DeleteIcon
								data-testid="delete-icon"
								className={styles['status-delete-stack']}
								fill={deleteIconFillColor}
							/>
						</Icon>
					)}
				</List>
			),
		},
	];

	const handleDelete = (id: string) => {
		const allUsers = selectedWorkflowStepQueueGridData?.filter(
			(user: any) => user.queueId !== id,
		);
		if (selectedWorkflowStepExistingQueueGridData?.length > 0) {
			const updatedUsersExistingData =
				selectedWorkflowStepExistingQueueGridData?.filter(
					(queueList: any) => queueList.queueId !== id,
				);
			setWorkflowStepExistingQueueGridData([...updatedUsersExistingData]);
		}

		setWorkflowStepQueueGridData(allUsers);
		onQueueListSelect(allUsers);
		addQueuesToList([]);

		const field = 'queueIds';
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[field]: allUsers,
		}));

		if (selectedWorkflowDetails.type === EDIT) {
			if (!isEqual(allUsers, selectedWorkflowDetails.data.queueDetail)) {
				setIsQueueValid(true);
			} else {
				setIsQueueValid(false);
			}
		}
	};

	const handleWorkflowInputChange = (value: any) => {
		const field = 'workflowStepName';
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[field]: value,
		}));
		if (
			value.length > 0 &&
			(selectedWorkflowDetails.type === EDIT ||
				selectedWorkflowDetails.type === CREATE)
		) {
			setIsSaveDisabled(false);
		} else if (value.length === 0) {
			setIsSaveDisabled(true);
		}
	};

	const drawerCloseHandler = useCallback(() => {
		dispatch(
			setToastMessage({
				message: '',
				severity: '',
				isToastOpen: false,
			}),
		);
		dispatch(setWorkflowStepDrawer(!openWorkflowDrawer));
	}, [openWorkflowDrawer]);

	const onQueueListSelect = (data: IQueueSearchList[]) => {
		setSelecteddWorkflowQueueListOptions(data);
	};

	const onQueueListAdd = () => {
		setWorkflowStepQueueGridData(selectedWorkflowQueueListOptions);
		const key = 'queueIds';
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[key]: selectedWorkflowQueueListOptions,
		}));

		if (selectedWorkflowDetails.type === EDIT) {
			if (
				selectedWorkflowQueueListOptions.length === 0 &&
				selectedWorkflowDetails.data.queueDetail.length === 0
			) {
				setIsQueueValid(false);
			} else if (
				!isEqual(
					selectedWorkflowQueueListOptions,
					selectedWorkflowDetails.data.queueDetail,
				)
			) {
				setIsQueueValid(true);
			} else {
				setIsQueueValid(false);
			}
		}
	};
	const onUsersListSelect = (data: IUserSelectListOptions[]) => {
		setAllSelectedUsersListOptions(data);
		const key = 'users';
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[key]: data,
		}));

		if (selectedWorkflowDetails.type === EDIT) {
			if (!isEqual(data, selectedWorkflowDetails.data.userDtoDetail)) {
				setIsUsersValid(true);
			} else {
				setIsUsersValid(false);
			}
		}
	};
	const addUsersToList = (data: any) => {
		const allUsersList = addUsersToStateList(data);
		return allUsersList;
	};
	const addQueuesToList = (data: IQueueSearchList[]) => {
		const displayQueueList = data.map((ele: any) => {
			const tempObj = { ...ele };
			tempObj.displayLabel = ele?.queueName;
			tempObj.label = ele?.queueName;
			tempObj.id = ele?.queueId;
			tempObj.checked = false;
			tempObj.isExisting = false;

			return tempObj;
		});

		return displayQueueList;
	};

	const updateFormData = (type: string, data: any) => {
		const key = type;
		setFormData((prevFormData: any) => ({
			...prevFormData,
			[key]: data,
		}));
	};
	const onSearchQueueTextChange = async (data: string) => {
		const type = 'queueIds';
		if (data && data?.length > 2) {
			setSearchLoading((previous: any) => ({ ...previous, [type]: true }));
			try {
				const resp = await getSearchQueueList(data);
				if (resp?.statusCode === OK) {
					if (resp?.responseBody) {
						const displayQueueList = addQueuesToList(resp?.responseBody);
						setWorkflowStepQueueOptions(displayQueueList);
					} else {
						setWorkflowStepQueueOptions([]);
					}

					setSearchLoading((previous: any) => ({ ...previous, [type]: false }));
				} else {
					setSearchLoading((previous: any) => ({ ...previous, [type]: false }));
					dispatch(
						setToastMessage({
							message: APP_GENERAL_ERROR_MSG,
							severity: 'error',
							isToastOpen: true,
						}),
					);
				}
			} catch (e) {
				setSearchLoading((previous: any) => ({ ...previous, [type]: false }));
				setToastOpen(true);
				dispatch(
					setToastMessage({
						message: GENERIC_ERROR_MSG,
						severity: 'error',
						isToastOpen: true,
					}),
				);
			}
		}
	};

	const debouncedSearchQueueHandler = debounce(onSearchQueueTextChange, 300);
	const buildCreatePayload = () => {
		const usersList = formData.users.map((ele: any) => {
			const userObj = {} as UserPayloadInterface;
			userObj.email = ele.email;
			userObj.userName = ele.userName;
			userObj.firstName = ele.firstName;
			userObj.lastName = ele.lastName;
			return userObj;
		});
		const queueIDs = formData.queueIds.map((ele: any) => ele?.queueId);
		formData.users = usersList;
		formData.queueIds = queueIDs;
		formData.workflowId = selectedWorkflowDetails?.data?.workflowId;
		formData.workflowStepName = formData.workflowStepName.trim();
		return formData;
	};
	const buildEditPayload = () => {
		const usersList = formData.users.map((ele: any) => {
			const userObj = {} as UserPayloadInterface;
			userObj.email = ele.email;
			userObj.userName = ele.userName;
			userObj.firstName = ele.firstName;
			userObj.lastName = ele.lastName;
			return userObj;
		});
		const queueIDs = formData.queueIds.map((ele: any) => ele?.queueId);
		const tempEditObj = {} as IEditWorkflowStepParams;
		tempEditObj.users = usersList;
		tempEditObj.queueIds = queueIDs;
		tempEditObj.workflowId = selectedWorkflowDetails.data.workflowId;
		tempEditObj.workflowStepId = selectedWorkflowDetails.data.workflowStepId;
		tempEditObj.workflowStepName = formData.workflowStepName.trim();
		return tempEditObj;
	};

	const onCreateWorkflowStep = async () => {
		const paramsData = buildCreatePayload();
		try {
			const resp = await createWorkflowStep(paramsData);
			if (resp?.statusCode === CREATED) {
				displaySuccessMessage('create');
			} else if (resp?.statusCode === BAD_REQUEST) {
				displayApiErrorMessage(resp);
			} else {
				setWorkflowLoading(false);
				setToastOpen(true);
				dispatch(
					setToastMessage({
						message: APP_GENERAL_ERROR_MSG,
						severity: 'error',
						isToastOpen: true,
					}),
				);
			}
		} catch (e) {
			setWorkflowLoading(false);
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: GENERIC_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const handleAccordionChange = (event: React.SyntheticEvent, type: string) => {
		event.stopPropagation();

		let val = false;
		if (type === 'queueIds') {
			val = accordionExpanded.queueIds;
			setExpanded((previous: any) => ({ ...previous, users: false }));
		} else {
			val = accordionExpanded.users;
			setExpanded((previous: any) => ({ ...previous, queueIds: false }));
		}
		setExpanded((previous: any) => ({ ...previous, [type]: !val }));
	};

	const onEditWorkflowStep = async () => {
		const paramsData = buildEditPayload();
		try {
			const resp = await updateWorkflowStep(paramsData);
			if (resp?.statusCode === OK) {
				displaySuccessMessage('edit');
			} else if (resp?.statusCode === BAD_REQUEST) {
				displayApiErrorMessage(resp);
			} else {
				setWorkflowLoading(false);
				setToastOpen(true);
				dispatch(
					setToastMessage({
						message: APP_GENERAL_ERROR_MSG,
						severity: 'error',
						isToastOpen: true,
					}),
				);
			}
		} catch (e) {
			setWorkflowLoading(false);
			setToastOpen(true);
			dispatch(
				setToastMessage({
					message: GENERIC_ERROR_MSG,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const displaySuccessMessage = (type: string) => {
		setWorkflowLoading(false);
		dispatch(setWorkflowStepDrawer(!openWorkflowDrawer));
		setToastOpen(true);
		dispatch(setWorkflowStepFlag(true));
		dispatch(
			setToastMessage({
				message:
					type === CREATE ? WORKFLOW_STEP_CREATED : WORKFLOW_STEP_UPDATED,
				severity: 'success',
				isToastOpen: true,
			}),
		);
	};

	const displayApiErrorMessage = (error: any) => {
		dispatch(
			setToastMessage({
				message: error?.errorBody?.errorMessage || APP_GENERIC_BAD_REQUEST_MSG,
				severity: 'error',
				isToastOpen: true,
			}),
		);
	};
	const handleClose = () => {
		setToastOpen(false);
	};

	useEffect(() => {
		if (selectedWorkflowDetails.type === CREATE) {
			setIsSaveDisabled(false);
		} else if (
			selectedWorkflowDetails.type === EDIT &&
			(isUsersValid || isQueueValid)
		) {
			setIsSaveDisabled(false);
		} else {
			setIsSaveDisabled(true);
		}
	}, [isUsersValid, isQueueValid]);

	useEffect(() => {
		if (selectedWorkflowDetails.type === EDIT) {
			// check for queue details and user details
			const existingQueueList = addQueuesToList(
				selectedWorkflowDetails.data.queueDetail,
			);
			const updateExistingListData = existingQueueList.map((ele: any) => {
				ele.isExisting = true;
				return ele;
			});
			setSelecteddWorkflowQueueListOptions(updateExistingListData);
			setWorkflowStepExistingQueueGridData(updateExistingListData);
			setWorkflowStepQueueGridData(updateExistingListData);
			updateFormData('queueIds', updateExistingListData);
			const existingUsersList = addUsersToList(
				selectedWorkflowDetails.data.userDtoDetail,
			);
			setAllSelectedUsersListOptions(existingUsersList);
			updateFormData('users', existingUsersList);
			updateFormData(
				'workflowStepName',
				selectedWorkflowDetails.data.workflowStepName,
			);
		} else {
			setIsSaveDisabled(true);
		}
		setWorkflowLoading(false);
	}, [selectedWorkflowDetails]);

	return (
		<Box
			className={styles['createworkflow-container']}
			role="presentation"
			data-testid="create-workflow-container"
		>
			<div className={styles['createworkflowmain-div']}>
				<div
					className={styles['createworkflow-text-background']}
					data-testid="workflow-top-div"
				>
					<Stack
						direction="row"
						justifyContent="flex-end"
						spacing={2}
						data-testid="workflow-button-stack"
					>
						<IconButton
							size="large"
							onClick={drawerCloseHandler}
							data-testid="workflowclose-groups-btn"
						>
							<DrawerClose fill={drawerCloseImgColor} />
						</IconButton>
					</Stack>

					<Box className={styles['createworkflow-text-box']}>
						<Stack direction="row" justifyContent="space-between">
							<Typography
								className={styles['createworkflow-text-name']}
								data-testid="workflow-text"
							>
								{selectedWorkflowDetails?.data.workflowName}
							</Typography>
						</Stack>
					</Box>
				</div>
			</div>
			<Grid
				item
				className={styles['createworkflow-form-layout']}
				xs={12}
				sm={12}
				md={12}
				xl={12}
				lg={12}
			>
				{!isWorkflowLoading ? (
					<form data-testid="form-module">
						<Grid container>
							<Grid item xs={12} sm={12} md={12} xl={12} lg={12} p={1}>
								<Typography className={styles['createworkflow-label']}>
									{CREATE_WORKFLOW_TITLE}
								</Typography>
							</Grid>

							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								xl={12}
								lg={12}
								p={1}
								className={styles['createworkflowstep-nopadding']}
							>
								<TextFieldWithLabel
									label={toSentenceCase('Workflow Step')}
									id="workflowstep-name"
									value={formData.workflowStepName}
									inputProps={{
										'data-testid': 'workflowstep-name',
									}}
									onChange={(e) => {
										handleWorkflowInputChange(e.target.value);
									}}
									required
									helperText=""
									showLabel
									placeholder=""
									className={styles['createworkflow-field-width']}
									positionClass={styles['word-limit-position']}
									wordLimit={250}
									error={false}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								xl={12}
								lg={12}
								p={1}
								className={styles['createworkflowstep-nopadding']}
							>
								<Typography className={styles['createworkflow-asignee']}>
									{CREATE_WORKFLOW_ASSIGNEE_LABEL}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								xl={12}
								lg={12}
								p={1}
								data-testid="workflowstep-queue-list"
							>
								<div className={styles['createworkflowstep-queue-top']}>
									<AccordionComp
										expanded={accordionExpanded.queueIds}
										onChange={(event) =>
											handleAccordionChange(event, 'queueIds')
										}
										className={styles['createworkflowstep-box-shadow']}
										data-testid="workflowstep-comp-module"
										key="queueIds"
										dataTestId="workflowstep-queue-accordion"
										summary={
											<Grid item>
												<Typography
													className={
														styles['createworkflowstep-selection-header']
													}
												>
													Queue
												</Typography>
											</Grid>
										}
										details={
											<>
												<Grid
													container
													direction="row"
													style={{ display: 'flex' }}
													className={styles['createworkflowstep-selection-row']}
												>
													<Grid item xs={8} sm={8} md={8} xl={9} lg={9} p={1}>
														<AutoComplete
															data={workflowStepQueueOptions}
															onUserSelect={onQueueListSelect}
															type="email"
															key="email"
															showLabel
															viewChange
															apiSearch
															displayLabel={toSentenceCase(
																'Search for a Queue',
															)}
															onTextChange={debouncedSearchQueueHandler}
															selectedData={selectedWorkflowStepQueueGridData}
															isSearchLoading={isSearchApiLoading.queueIds}
														/>
													</Grid>
													<Grid item xs={4} sm={4} md={4} xl={3} lg={3} p={1.6}>
														<ButtonComp
															btnType="primary"
															data-testid="createqueue-add-queue"
															compClass={
																styles[
																	'createworkflowstep-selection-add-users-btn'
																]
															}
															clickHandler={onQueueListAdd}
															disabled={
																selectedWorkflowQueueListOptions?.length ===
																	0 &&
																selectedWorkflowStepQueueGridData.length === 0
															}
														>
															{toSentenceCase(ADD_QUEUES)}
														</ButtonComp>
													</Grid>
												</Grid>
												<Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
													<Typography
														className={
															styles['createworkflowstep-selection-note-text']
														}
													>
														<span
															className={
																styles[
																	'createworkflowstep-selection-note-weight'
																]
															}
														>
															Note
														</span>
														<span
															className={
																styles[
																	'createworkflowstep-selection-note-sub-text'
																]
															}
														>
															: Please choose the queues you wish to add by
															searching and selecting the checkboxes.
														</span>
													</Typography>
												</Grid>

												<div className={styles['groups-table-container']}>
													{selectedWorkflowStepQueueGridData?.length > 0 ? (
														<div
															className={
																styles['createworkflow-queue-grid-container']
															}
														>
															<CommonTable
																rows={selectedWorkflowStepQueueGridData}
																columns={queueColumns}
																enableHeaderColor
																hidePagination
																tableStyles={{ maxHeight: '15rem !important' }}
																customStylesEnabled
															/>
														</div>
													) : (
														<div>
															<List
																dense
																data-testid="main-list"
																className={styles['createworkflow-queue-list']}
																subheader={
																	<ListSubheader
																		className={
																			styles[
																				'createworkflow-queue-list-sublist'
																			]
																		}
																	>
																		<ListItem disablePadding>
																			<ListItemText
																				id="name"
																				primary="Queue"
																				className={
																					styles[
																						'createworkflow-queue-list-sublistwidth'
																					]
																				}
																			/>
																			<ListItemText
																				id="action"
																				primary="Action"
																				className={
																					styles[
																						'createworkflow-queue-list-sublistwidth'
																					]
																				}
																			/>
																		</ListItem>
																	</ListSubheader>
																}
															>
																<Typography className={styles['no-data']}>
																	No queues added
																</Typography>
															</List>
														</div>
													)}
												</div>
											</>
										}
									/>
								</div>

								<div className={styles['createworkflowstep-divider']}>
									<span>and/or</span>
								</div>

								<div className={styles['createworkflowstep-usermod-top']}>
									<AccordionComp
										expanded={accordionExpanded.users}
										onChange={(event) => handleAccordionChange(event, 'users')}
										className={styles['createworkflowstep-box-shadow']}
										data-testid="accordian-comp-usermodule"
										key="users"
										dataTestId="users-accordion"
										summary={
											<Grid item>
												<Typography
													className={
														styles['createworkflowstep-selection-header']
													}
												>
													Person
												</Typography>
											</Grid>
										}
										details={
											<UsersListSelection
												onUserListItemSelect={onUsersListSelect}
												existingUsersData={selectedUsersListOptions}
												hideLabel
												actionType={selectedWorkflowDetails.type}
											/>
										}
									/>
								</div>
							</Grid>
						</Grid>
					</form>
				) : (
					<Loader show={isWorkflowLoading} />
				)}
			</Grid>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				xl={12}
				lg={12}
				p={1}
				className={styles['btn-position']}
			>
				<Stack direction="row" className={styles['btn-grouppermissionbutton']}>
					<ButtonComp
						clickHandler={drawerCloseHandler}
						btnType="secondary"
						data-testid="cancel-btn"
						compClass={styles['btn-cancel']}
					>
						{APP_GENERAL_CANCEL_LABEL}
					</ButtonComp>
					<ButtonComp
						btnType="primary"
						clickHandler={
							selectedWorkflowDetails?.type === CREATE
								? onCreateWorkflowStep
								: onEditWorkflowStep
						}
						disabled={isSaveDisabled}
						data-testid="save-btn"
						compClass={styles['btn-save']}
					>
						{selectedWorkflowDetails?.type === CREATE
							? 'Add'
							: APP_GENERAL_SAVE_LABEL}
					</ButtonComp>
				</Stack>
			</Grid>
			<AlertComponent
				open={isToastOpen}
				toastMessage={message ?? ''}
				severity={severity ?? ''}
				handleCloseMessage={handleClose}
				vertical="top"
				horizontal="right"
			/>
		</Box>
	);
};

export default WorkflowStep;
